const initialState = () => ({
  plans: [],
  services: [],
});

export default initialState;
